document.addEventListener('DOMContentLoaded', function() {
    const searchToggle = document.getElementById('search-toggle');
    const search = document.querySelector('.search');
    
    if (searchToggle && search) {
        searchToggle.addEventListener('click', function(e) {
            e.stopPropagation();

            const mobileMenu = document.querySelector('#menu-main--mobile__wrapper');
            const hamburger = document.querySelector('#hamburger-toggle');
            if (mobileMenu && mobileMenu.classList.contains('active')) {
                mobileMenu.classList.remove('active');
                if (hamburger) {
                    hamburger.classList.remove('active');
                }

                document.body.classList.remove('menu-mobile-visible');
            }

            search.classList.toggle('active');
            document.body.classList.toggle('search-active');
        });

        document.addEventListener('click', function(e) {
            if (document.body.classList.contains('search-active')) {
                // If click is outside search and not on toggle
                if (!search.contains(e.target) && !searchToggle.contains(e.target)) {
                    search.classList.remove('active');
                    document.body.classList.remove('search-active');
                }
            }
        });
        
        // Close on Escape
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && document.body.classList.contains('search-active')) {
                search.classList.remove('active');
                document.body.classList.remove('search-active');
            }
        });
    }
});
